import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
    description = "description",
    icon = "icon",
    borderLeftColor = "borderLeftColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
        [fields.description]: string;
        [fields.icon]: string;
        [fields.borderLeftColor]: string;
    };
}

type Props = OwnProps & WidgetProps;

export interface CENSignInAlertMessageStyles {
    container?: InjectableCss;
    iconStyles?: InjectableCss;
}

export const cenSignInAlertMessageStyles: CENSignInAlertMessageStyles = {
    iconStyles: {
        css: css`
            width: 16px;
            margin-right: 4px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 5px;
                    `,
                    css`
                        margin-top: 5px;
                    `,
                    css`
                        margin-top: 5px;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 992px) and (max-width: 1250px) {
                margin-top: 5px !important;
            }
        `,
    },
};

const styles = cenSignInAlertMessageStyles;

const CENSignInAlertMessage: FC<Props> = ({ fields }) => {
    const container = {
        css: css`
            background: ${fields.backgroundColor};
            display: flex;
            justify-content: flex-start;
            margin-top: 32px;
            margin-bottom: 32px;
            align-items: center;
            padding: 16px;
            border-left: 4px solid ${fields.borderLeftColor};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        align-items: flex-start;
                        margin-top: 24px;
                        margin-bottom: 24px;
                    `,
                    css`
                        align-items: flex-start;
                        margin-top: 24px;
                        margin-bottom: 24px;
                    `,
                    css`
                        align-items: flex-start;
                    `,
                    null,
                    null,
                ])}
            @media (min-width: 992px) and (max-width: 1250px) {
                align-items: flex-start !important;
            }
        `,
    };

    return (
        <StyledWrapper {...container}>
            <Img src={fields.icon} {...styles.iconStyles} altText={fields.description} />
            <Typography as="p">{parse(transformContentHtml(fields.description), parserOptions)}</Typography>
        </StyledWrapper>
    );
};

const CENsignInAlertMessage: WidgetModule = {
    component: CENSignInAlertMessage,
    definition: {
        group: "Basic",
        displayName: "CENSignInAlertMessage",
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                fieldType: "General",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                displayName: "Background Color",
            },
            {
                name: fields.borderLeftColor,
                fieldType: "General",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                displayName: "Border Color",
            },
            {
                name: fields.icon,
                fieldType: "General",
                displayName:"Icon",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
            {
                name: fields.description,
                fieldType: "General",
                displayName:"Description",
                editorTemplate: "RichTextField",
                defaultValue: "",
            },
        ],
    },
};

export default CENsignInAlertMessage;
